import * as Yup  from 'yup';
import { rules } from '../shared/rules';

export const fullNameRegex = /^\p{L}+([-'\u2019]\p{L}+)*(\s+\p{L}+([-'\u2019]\p{L}+)*){1,2}$/u;

export const signUpFormSchema = Yup.object().shape({
  fullName: Yup.string()
    .trim()
    .nullable()
    .required('Full Name is required')
    .max(200, 'Full Name is too long')
    .matches(fullNameRegex, { message: 'Please provide your First and Last name' }),
  email       : rules.email,
  phoneNumber : Yup.string()
    .nullable()
    .transform((value) => value?.trim() || null)
    .required('Phone Number is required')
    .matches(/^\+?\d+$/, 'Invalid phone number')
    .min(11, 'Phone number must be at least 11 characters long'),
  password        : rules.password,
  confirmPassword : Yup.string()
    .required('Confirm your password')
    .oneOf([ Yup.ref('password'), null ], 'Passwords must match'),
  news: Yup.boolean().nullable(),
}, [ [ 'password', 'confirmPassword' ] ]);
